import "./WhyChooseUs.css";

const WhyChooseUs = () => {
  const reasons = [
    {
      title: "Execution",
      highlight: "First",
      description:
        "Ideas are easy execution wins. We build, test and deploy fast.",
    },
    {
      title: "Domain",
      highlight: "Mastery",
      description:
        "Our portfolio spans tech, politics, media, & entertainment fueling industry solutions.",
    },
    {
      title: "Team of",
      highlight: "Specialists",
      description:
        "Every project is led by subject matter experts, not generalists because precision matters.",
    },
    {
      title: "Outcome",
      highlight: "Obsessed",
      description:
        "We measure everything. From click to conversion, your KPIs guide our strategy.",
    },
    {
      title: "Agile.",
      highlight: "Adaptive.",
      description:
        "We stay on top of the latest tools, tech, so your brand always stays ahead.",
    },
  ];

  return (
    <>
      <div className="container-fluid py-5">
        <div className="container">
          {/* Header */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="display-4 fw-bold mb-0">
                Why <span className="text-yellow">Choose Us</span> ?
              </h2>
            </div>
          </div>

          {/* Content Grid */}
          <div className="row g-4">
            {reasons.map((reason, index) => (
              <div key={index} className="col-lg col-md-6 col-12">
                <div className="text-center h-100 d-flex flex-column">
                  <div className="mb-4">
                    <h3 className="h2 fw-bold mb-2" style={{ color: "#333" }}>
                      {reason.title}
                    </h3>
                    <h3 className="h3 fw-bold text-yellow">
                      {reason.highlight}
                    </h3>
                  </div>
                  <p
                    className="text-muted lead flex-grow-1 fs-5"
                    style={{ fontSize: "1rem", lineHeight: "1.6" }}
                  >
                    {reason.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyChooseUs;
